import React, { useState } from "react";

const IEC = () => {
    const [openSection, setOpenSection] = useState(null);
  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };
  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };

  return (
    <div className="p-6">
    <div className="p-8 bg-gray-100">
      {/* Title Section */}
      <h1 className="text-3xl font-bold text-center mb-6">
        Import Export Code (IEC)
      </h1>
      <p className="text-gray-700 mb-6 text-justify                ">
        IMPORT EXPORT CODE or IEC refers to a 10-digit identification number
        that is issued by the Directorate General of Foreign Trade (DGFT),
        Ministry of Commerce and Industries, Government of India to the
        applicant who is involved in any kind of import or export of goods or
        services from India.
      </p>

      {/* Key Features Section */}
      {/* <div
          className={`border rounded-lg ${
            openSection === 1 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
        <button
          onClick={() => toggleSection(1)}
          className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
        >
          1. Details and Documents Required. 
          <span>{openSection === 1 ? "-" : "+"}</span>
        </button>
        {openSection=== 1 && (
           <div className="px-4 py-3 bg-white text-gray-700">
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Copy of Entity’s PAN Card</li>
            <li>Business Address Proof</li>
            <li>Photograph and KYC of Directors or</li>
            <li>Partners or Proprietor</li>
            <li>Valid Indian Mobile no. of Director or Partners or Proprietor</li>
            <li>Charter documents of Entities</li>
            <li>Letter of Authorized Signatory/Board Resolution</li>
            <li>Director or Partners or Proprietor e-mail ID</li>
            <li>Cancelled Cheque or Pass Book or Bank Statementb</li>
          </ul>
          </div>
        )}
      </div> */}

<div className="space-y-4 mx-4 sm:mx-10 lg:mx-40">
        {/* Section 1 */}
        <div
          className={`border rounded-lg ${
            openSection === 1 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(1)}
            className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
          >
            1. Details and Documents Required. 
            <span>{openSection === 1 ? "-" : "+"}</span>
          </button>
          {openSection === 1 && (
            <div className="px-4 py-3 bg-white text-gray-700">
          <ul className="list-disc list-inside mt-2 space-y-1">
           <li>Copy of Entity’s PAN Card</li>
           <li>Business Address Proof</li>
           <li>Photograph and KYC of Directors or</li>
           <li>Partners or Proprietor</li>
           <li>Valid Indian Mobile no. of Director or Partners or Proprietor</li>
           <li>Charter documents of Entities</li>
           <li>Letter of Authorized Signatory/Board Resolution</li>
           <li>Director or Partners or Proprietor e-mail ID</li>
           <li>Cancelled Cheque or Pass Book or Bank Statementb</li>
            </ul>
          </div>
          )}
        </div>
        </div>

      {/* Get in Touch Section */}
      <div className="mt-8 bg-gray-50 p-6 rounded-md shadow-sm px-6 lg:px-20">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Get in touch</h2>
        <p className="text-gray-600 mb-6 j text-justify">
          If you have any queries or questions, please reach out to us by clicking on the contact button and filling out the form.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4">
          {/* Make Appointment Button */}
          <button onClick={handleAppointmentClick} className="px-6 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 transition duration-200">
            Make Appointment
          </button>

          {/* Contact Us Button */}
          <button className="px-6 py-2 bg-[#005A8C] text-white rounded hover:bg-blue-600 transition duration-200">
            Contact Us
          </button>
        </div>
      </div>
    </div>
    </div>
  );
};

export default IEC;
